import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, unref as _unref, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col text-block gap-4" }

import { computed } from 'vue';
import ToggleSwitchCardItem from './ToggleSwitchCardItem.vue';
import InformationBox from '@/components/InformationBox/InformationBox.vue';
import { InformationBoxTypes } from '@/interfaces/forms/information-box.interface';
import { IToggleSwitchCardItem } from '@/interfaces/components/toggle-switch-card.interface';

// Receive items array from parent

export default /*@__PURE__*/_defineComponent({
  __name: 'ToggleSwitchCard',
  props: {
    items: {},
    disabledAllMessage: {}
  },
  emits: ["update"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// Emit whenever a toggle changes
const emit = __emit;

// Computed → are all toggles disabled?
const allDisabled = computed(() => props.items.length > 0 && props.items.every((i) => i.modelValue == false));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
        return (_openBlock(), _createBlock(ToggleSwitchCardItem, {
          id: item.id,
          key: item.id,
          title: item.title,
          description: item.description,
          modelValue: item.modelValue,
          disabled: item.disabled,
          onChange: _cache[0] || (_cache[0] = (payload) => emit('update', payload))
        }, null, 8, ["id", "title", "description", "modelValue", "disabled"]))
      }), 128))
    ]),
    (allDisabled.value && _ctx.disabledAllMessage)
      ? (_openBlock(), _createBlock(InformationBox, {
          key: 0,
          class: "mt-6",
          description: _ctx.disabledAllMessage,
          type: _unref(InformationBoxTypes).WARNING
        }, null, 8, ["description", "type"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})